import styled from 'styled-components';
import { GRAY200, HOVER } from '../../../theme';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const StyledFormContent = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 8px;
  gap: 8px;
  height: 100%;
`;

export const StyledFormFooter = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  padding: 8px;
`;

export const TemplateItem = styled.li`
  border-bottom: 1px solid var(--main-border, ${GRAY200});
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  white-space: pre-line;
  &:hover {
    background-color: var(--main-hover, ${HOVER});
  }
  &:last-child {
    border-bottom: none;
  }
`;
